import { SxProps, Theme } from "@mui/material";

export default (theme: Theme): Record<string, SxProps<Theme>> => ({
  container: {
    flex: "0 0 auto",
    displayPrint: "none",
    width: "240px",
    height: "100vh",
    m: 0,
    p: 0,
    background: "var(--color-white)",
    boxSizing: "border-box",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },

  figure: {
    alignItems: "flex-start",
    m: "calc(0.5 * var(--rhythm)) 0 0 0",
    p: "var(--rhythm)",
    img: {
      height: "calc(1.5 * var(--rhythm))",
    },
    figcaption: {
      fontSize: "var(--font-size-xs)",
    },
  },

  title: {
    mt: "calc(-1 * var(--rhythm))",
    mb: "calc(-0.5 * var(--rhythm))",
    p: "var(--rhythm)",
  },

  alert: {
    fontSize: "var(--font-size-m)",
  },
});
